"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMFs = findMFs;
const findMFsSync_1 = require("./findMFsSync");
/** @typedef {import('./types').MFResult} MFResult */
/** @typedef {import('./types').MFFinderOptions} MFFinderOptions */
/**
 * @param {number} targetMass - Monoisotopic mass
 * @param {MFFinderOptions} [options={}]
 * @returns {Promise<MFResult[]>}
 */
async function findMFs(targetMass, options = {}) {
    return (0, findMFsSync_1.findMFsSync)(targetMass, options);
}
//# sourceMappingURL=findMFs.js.map